import { createContext } from 'react';

interface ClientStyleContextData {
  reset: () => void;
}

export const ClientStyleContext = createContext<ClientStyleContextData>({
  reset: () => {},
});
